document.addEventListener('DOMContentLoaded', () => {
  // ======================================================================================
  // PART 1: SETUP DRAWER AND HELPERS
  // ======================================================================================
  const quickViewDrawer = document.getElementById('QuickViewDrawer');
  if (!quickViewDrawer) return;

  const quickViewBody = document.getElementById('QuickViewBody');
  const closeButton = quickViewDrawer.querySelector('.quick-view__close');
  const overlay = quickViewDrawer.querySelector('.quick-view__overlay');

  const openDrawer = () => {
    document.body.style.overflow = 'hidden';
    quickViewDrawer.classList.add('is-open');
  };

  const closeDrawer = () => {
    document.body.style.overflow = '';
    quickViewDrawer.classList.remove('is-open');
    setTimeout(() => {
      if (quickViewBody) {
        quickViewBody.innerHTML = `
          <div class="quick-view-loading"><div class="spinner"></div></div>
        `;
      }
    }, 400);
  };

  if (closeButton) closeButton.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  const formatMoney = (cents, currency = '$') => {
    if (typeof cents !== 'number') cents = parseInt(cents, 10);
    return `${currency}${(cents / 100).toFixed(2)}`;
  };

  // ======================================================================================
  // PART 2: TRIGGER INIT
  // ======================================================================================
  const initQuickViewTriggers = () => {
    const triggers = document.querySelectorAll('.quick-view-trigger:not([data-qv-initialized])');

    triggers.forEach(button => {
      button.dataset.qvInitialized = 'true';
      button.addEventListener('click', e => {
        e.preventDefault();
        const handle = button.dataset.productHandle;
        if (!handle) return;

        openDrawer();

        fetch(`/products/${handle}.js`)
          .then(res => {
            if (!res.ok) throw new Error(`Fetch failed: ${res.statusText}`);
            return res.json();
          })
          .then(product => {
            const variant = product.variants.find(v => v.available) || product.variants[0];
            const isOnSale =
              variant.compare_at_price &&
              parseFloat(variant.compare_at_price) > parseFloat(variant.price);

            let priceHtml = '';
            if (isOnSale) {
              const savings = Math.round(
                ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
              );
              priceHtml = `
                <div class="qv-product__pricing">
                  <del class="qv-compare-price">${formatMoney(variant.compare_at_price)}</del>
                  <span class="qv-price">${formatMoney(variant.price)}</span>
                  ${savings > 0 ? `<span class="qv-discount-badge">SAVE ${savings}%</span>` : ''}
                </div>`;
            } else {
              priceHtml = `
                <div class="qv-product__pricing">
                  <span class="qv-price">${formatMoney(variant.price)}</span>
                </div>`;
            }

            const productHtml = `
              <div class="qv-product">
                <div class="qv-product__media">
                  <div class="qv-vertical-slider">
                    ${product.images
                      .map(
                        img =>
                          `<div class="qv-slide">
                             <img src="${img.replace(/(\.[^.]*)$/, '_800x$1')}" 
                                  alt="${product.title}" loading="lazy">
                           </div>`
                      )
                      .join('')}
                  </div>
                </div>
                <div class="qv-product__info">
                  <h2 class="qv-product__title">${product.title}</h2>
                  ${priceHtml}
                  <form method="post" action="/cart/add" enctype="multipart/form-data">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${variant.id}">
                    ${product.options
                      .map(
                        (option, idx) => `
                          <fieldset class="qv-product__options">
                            <legend>
                              <strong>${option.name}:</strong>
                              <span id="selected-option-${idx}" class="selected-option-value"></span>
                            </legend>
                            <div class="qv-options-grid">
                              ${[...new Set(product.variants.map(v => v.options[idx]))]
                                .map(
                                  val => `
                                    <div>
                                      <input type="radio" id="qv-${product.id}-${option.name}-${val}"
                                             name="option-${idx}" value="${val}" 
                                             ${idx === 0 ? 'checked' : ''}>
                                      <label for="qv-${product.id}-${option.name}-${val}">
                                        ${val}
                                      </label>
                                    </div>`
                                )
                                .join('')}
                            </div>
                          </fieldset>`
                      )
                      .join('')}
                    <div class="qv-quantity-wrapper">
                      <div class="qv-quantity-controls">
                        <button type="button" class="qv-qty-btn" 
                                onclick="this.nextElementSibling.stepDown()">−</button>
                        <input type="number" id="qv-quantity" name="quantity" value="1" min="1" readonly>
                        <button type="button" class="qv-qty-btn" 
                                onclick="this.previousElementSibling.stepUp()">+</button>
                      </div>
                    </div>
                    <button type="submit" name="add" class="qv-add-to-cart-btn">ADD TO CART</button>
                  </form>
                </div>
              </div>`;

            if (quickViewBody) quickViewBody.innerHTML = productHtml;

            const form = quickViewBody.querySelector('form');
            if (form) {
              const variantInputs = form.querySelectorAll('input[type="radio"]');
              const hiddenIdInput = form.querySelector('input[name="id"]');

              const updateVariant = () => {
                const selected = Array.from(product.options, (opt, i) => {
                  const checked = form.querySelector(`input[name="option-${i}"]:checked`);
                  if (checked) {
                    const label = document.getElementById(`selected-option-${i}`);
                    if (label) label.textContent = checked.value;
                    return checked.value;
                  }
                });
                const match = product.variants.find(v =>
                  v.options.every((opt, i) => opt === selected[i])
                );
                if (match) hiddenIdInput.value = match.id;
              };

              variantInputs.forEach(input => input.addEventListener('change', updateVariant));
              updateVariant();
            }
          })
          .catch(err => {
            console.error('Quick View Error:', err);
            if (quickViewBody) quickViewBody.innerHTML = `<p>Could not load product details.</p>`;
          });
      });
    });
  };

  // ======================================================================================
  // PART 3: OBSERVER + INITIAL RUN
  // ======================================================================================
  const observerTarget = document.querySelector('#MainContent') || document.body;
  const observer = new MutationObserver(initQuickViewTriggers);
  observer.observe(observerTarget, { childList: true, subtree: true });

  initQuickViewTriggers();
});
